<script setup lang="ts">
import { useAuth } from '@acme/auth'
import StatusPage from './StatusPage.vue'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const auth = useAuth()
const router = useRouter()
const failed = ref(false)

onMounted(async () => {
  try {
    const returnPath = await auth.handleCallback()
    await router.replace(returnPath)
  } catch (error) {
    console.error('Sign-in callback failed', error)
    failed.value = true
  }
})
</script>

<template>
  <div class="callback">
    <StatusPage v-if="failed" kind="error" />
    <p v-else class="callback__text" aria-live="polite">{{ t('shell.signingIn') }}…</p>
  </div>
</template>

<style scoped>
.callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.callback__text {
  color: var(--text-secondary);
  font-size: var(--type-subheadline-size);
}
</style>
